export default class CrewListMember {
    rank;
    name;
    nationality;
    dateOfBirth;
    placeOfBirth;
    passportId;
    qualificationsAccToSTCW;
    seamansRecordBook;
    employmentContract;
    visa;
    constructor(crewListMember = {}) {
        Object.assign(this, crewListMember);
    }
}
//# sourceMappingURL=CrewListMember.js.map